module.exports = __webpack_public_path__ + "media/3-43.a0b7d68e.wav";